import "../styles/PersonList.scss";
import React from "react";
import { Link } from "react-router-dom";

interface Person {
    id: number;
    name: string;
    profile_path?: string;
    character?: string;
    roles?: { character: string }[];
    total_episode_count?: number;
}

const PersonList = ({ people }: { people: Person[] | undefined }) => {

    if (!people) return <div>Error loading People.</div>;
    if (people.length === 0) return <></>;

    return (
        <div className="person-list">
            <h2 className="person-list--title">Cast</h2>
            <div className="person-list--scrollable">
                {people.map(person => {
                    if (!person.character) {
                        person.character = '';
                    }

                    return (
                        person.profile_path &&
                        <Link to={`/people/${person.id}`} key={person.id} className="card">
                            <img src={`https://image.tmdb.org/t/p/w300${person.profile_path}`} alt={person.name} loading="lazy" />
                            <h3 className="name" title={person.name}>{person.name}</h3>
                            <p className="character" title={person.character}>{person.character}</p>
                            {person.total_episode_count != null && person.total_episode_count > 0 && (
                                <p className="episode-count" title={`${person.total_episode_count} episodes`}>{`${person.total_episode_count} episodes`}</p>
                            )}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}

export default PersonList;